import { render, staticRenderFns } from "./crimeLocations.vue?vue&type=template&id=8ac85d36&scoped=true"
import script from "./crimeLocations.vue?vue&type=script&lang=js"
export * from "./crimeLocations.vue?vue&type=script&lang=js"
import style0 from "./crimeLocations.vue?vue&type=style&index=0&id=8ac85d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac85d36",
  null
  
)

export default component.exports